module.exports = __webpack_public_path__ + "static/quality_badge-e79414abb0dbf57e2bfa2b070134ade6.svg";